import { Reducer } from "redux";

import { ApiErrorStore } from "../../../types/ReduxTypes/StoreTypes";
import { SET_API_ERROR } from "./types";

const initialState: ApiErrorStore = {
  apiError: "",
};

const apiErrorReducer: Reducer<ApiErrorStore> = (state = initialState, action) => {
  switch (action.type) {
    case SET_API_ERROR:
      return { ...state, apiError: action.payload };
    default:
      return state;
  }
};

export default apiErrorReducer;
